import React, { useEffect, useState } from "react";

const ServiceSteps = ({ steps = [] }) => {
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setCurrentStep((prev) => {
        if (prev + 1 >= steps.length) {
          return 0;
        }
        return prev + 1;
      });
    }, 2000);
    return () => {
      clearInterval(id);
    };
  }, []);
  return (
    <>
      <div className="mb-wiz">
        <div className="wizard">
          <div className="process">
            <ul>
              {steps.map((item, index) => {
                return (
                  <li
                    className={`step ${
                      index <= currentStep
                        ? index == currentStep
                          ? "current"
                          : "completed"
                        : ""
                    }`}
                  >
                    {index == currentStep ? (
                      <img
                        className="cr-car"
                        src="/assets/thank-you/car-mb.png"
                      />
                    ) : null}
                    <span>{index + 1}</span>
                    <div className="name">{item}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="stp-wizard-elm">
        <ul className="form-stepper form-stepper-horizontal text-center mx-auto pl-0 stp-8">
          {steps.map((item, index) => {
            return (
              <li
                className={`${
                  currentStep >= index
                    ? currentStep != index
                      ? "form-stepper-completed"
                      : "form-stepper-active"
                    : "form-stepper-unfinished"
                } text-center form-stepper-list`}
                step={index + 1}
              >
                {currentStep == index ? (
                  <label className="sl-car-active">
                    <img src="/assets/thank-you/car.png" />{" "}
                  </label>
                ) : null}
                <a className="mx-2">
                  <span className="form-stepper-circle">
                    <span>{index + 1}</span>
                  </span>
                  <div className="label">{item}</div>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default ServiceSteps;
